<template>
  <div class="user-add-form">
    <h1>User Add Form</h1>
    <b-form @submit="submitForm" v-if="!formState.submitted">
      <b-container>
        <b-row>
          <b-col md="4">
            <b-form-group label="First Name">
              <b-form-input
                v-model="formData.firstName"
                placeholder="first name"
                :state="firstNameValidation.getState(formState.validate)"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="firstNameValidation.getState(formState.validate)"
                >{{ firstNameValidation.errorMessage }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Middle Name">
              <b-form-input
                v-model="formData.middleName"
                placeholder="middle name"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Last Name">
              <b-form-input
                v-model="formData.lastName"
                placeholder="last name"
                :state="lastNameValidation.getState(formState.validate)"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="lastNameValidation.getState(formState.validate)"
                >{{ lastNameValidation.errorMessage }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Email">
          <b-form-input
            v-model="formData.email"
            placeholder="email"
            :state="emailValidation.getState(formState.validate)"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="emailValidation.getState(formState.validate)"
            >{{ emailValidation.errorMessage }}</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group label="Pronouns">
          <b-form-select
            v-model="formData.pronouns"
            placeholder="Pronouns"
            :options="pronouns"
            :state="pronounsValidation.getState(formState.validate)"
          ></b-form-select>
          <b-form-invalid-feedback
            :state="pronounsValidation.getState(formState.validate)"
            >{{ pronounsValidation.errorMessage }}</b-form-invalid-feedback
          >
        </b-form-group>

        <b-form-group label="Bio">
          <b-form-textarea
            v-model="formData.bio"
            placeholder="Bio"
          ></b-form-textarea>
        </b-form-group>

        <b-button type="submit" variant="primary">submit</b-button>
        <b-button variant="link" @click="handleCancel">cancel</b-button>
      </b-container>
    </b-form>
    <div v-else>
      <p>
        The user has been created.
        <a :href="`${userAdminUrl}${newUser.id}`"
          >Click here to continue editing their profile.</a
        >
      </p>
    </div>
  </div>
</template>
<script>
import {
  BForm,
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BFormInvalidFeedback
} from "bootstrap-vue";
import { IsNotEmptyString } from "../lib/Validation";
import { IsValidEmail } from "../lib/Validation";
import MentorApplicationApi from "../lib/MentorApplicationApi";

export default {
  name: "UserAddForm",
  components: {
    BForm,
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    BFormInvalidFeedback
  },
  computed: {
    firstNameValidation() {
      return IsNotEmptyString(this.formData.firstName);
    },
    lastNameValidation() {
      return IsNotEmptyString(this.formData.lastName);
    },
    emailValidation() {
      return IsValidEmail(this.formData.email);
    },
    pronounsValidation() {
      return IsNotEmptyString(this.formData.pronouns);
    },
    hasValidationErrors() {
      // each field on the form has to be listed here in order for it to work
      let checklist = [
        this.firstNameValidation,
        this.lastNameValidation,
        this.emailValidation,
        this.pronounsValidation
      ];

      return checklist.some(x => true !== x.isValid);
    }
  },
  data() {
    return {
      api: new MentorApplicationApi(this.apiRootUrl),
      formData: {
        firstName: this.initialFirstName,
        middleName: this.initialMiddleName,
        lastName: this.initialLastName,
        email: this.initialEmail,
        pronouns: this.initialPronouns,
        bio: this.initialBio
      },
      formState: {
        submitted: false,
        submitting: false,
        validate: false,
        isEditing: true
      },
      pronouns: ["he/him/his", "she/her/hers", "they/them/theirs"],
      newUser: {}
    };
  },
  props: {
    userId: String,
    initialFirstName: String,
    initialMiddleName: String,
    initialLastName: String,
    initialEmail: String,
    initialPronouns: String,
    initialBio: String,
    apiRootUrl: {
      type: String,
      required: true
    },
    userAdminUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.formState.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      this.formState.submitting = true;
      this.formState.isEditing = false;

      let that = this;
      this.api
        .userAdd(this.formData)
        .then(
          response => {
            that.formState.submitted = true;
            that.formState.submitting = false;
            that.formState.isEditing = true;
            that.newUser = response.data.newUser;
          },
          error => {
            that.formState.submitting = false;
            that.formState.isEditing = true;
            alert(
              `Unable to submit: ${
                null === error?.response?.data?.error
                  ? "unknown error"
                  : error.response.data.error
              }`
            );
          }
        )
        .catch(() => {
          alert(`Unknown error logging your submission`);
          that.formState.submitting = false;
          that.formState.isEditing = true;
        });
    },
    handleCancel() {
      return;
    }
  }
};
</script>
